import { render, staticRenderFns } from "./dataLive.vue?vue&type=template&id=9b9763d8&scoped=true&"
import script from "./dataLive.vue?vue&type=script&lang=js&"
export * from "./dataLive.vue?vue&type=script&lang=js&"
import style0 from "./dataLive.vue?vue&type=style&index=0&id=9b9763d8&prod&lang=less&scoped=true&"
import style1 from "./dataLive.vue?vue&type=style&index=1&id=9b9763d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9763d8",
  null
  
)

export default component.exports